import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IncidentStatus } from '@api/incidents';

@Component({
  imports: [NgClass],
  selector: 'app-incident-status',
  styleUrls: ['./incident-status.component.scss'],
  template: `<span
    class="status-block"
    [ngClass]="{
      'status-in-progress': status === incidentStatus.INPROGRESS,
      'status-in-queue': status === incidentStatus.NEW,
      'status-resolved': status === incidentStatus.RESOLVED
    }"
  >
    {{ statusText[status] }}
  </span>`,
})
export class IncidentStatusComponent {
  @Input() status!: IncidentStatus;
  statusText = {
    [IncidentStatus.NEW]: 'In queue',
    [IncidentStatus.INPROGRESS]: 'In progress',
    [IncidentStatus.RESOLVED]: 'Resolved',
    [IncidentStatus.ARCHIVED]: 'Archived',
  };
  incidentStatus = IncidentStatus;
}
